import React from "react";
import "../App.css";

import AppLogo from "../assets/appLogo.png";

import {
    ColourPalette,
    downloadButtons,
    getAdjustingFontSizeByHeightWidth,
    getIsMobile,
    getMobileDownloadButtonValues,
    getScreenSize,
    getSectionHeight,
    pageType,
} from "../globalConstants";
import { DownloadButtonsDesktop } from "./DownloadButtonsDesktop";
import { trackDownloadClick } from "../analytics/events";
import GamePlayScreenShot from "../assets/gamePlayScreenShot.png"
import BluffsPie from "../assets/preflopPie.png"
import DelighterStill from "../assets/playStoreDelighterTop10pcimage.webp"
import { WhiteOutlineText } from "./whiteOutlineText";
import { FlexiblePhoneStillImage } from "./flexiblePhone";

const header0_1 = "The Poker App for"
const header0_2 = "Strategic Minds."

const headerLevel1 = "Poker with the luck removed."

const headerLevel2 = "Get dealt the same hands as everyone else.\nSee if you can play them better!"
const headerLevel2_mobile_1 = "Get dealt the same hands as everyone else."
const headerLevel2_mobile_2 = "See if you can play them better!"
const headerLevel2_Tablet_2 = "See if you can play them better!"
const headerLevel2_mobile_3 = "(It's really fun!)"

const headerLevel3 = "Start Winning Smarter Today - For Free"

export const formatHeader = (answer: string, style) => {
    if (answer == null) return null;
    try {
        return (
            <div style={{ width: "100%" }}>
                {answer.split('\n').map((line, index) => (
                    <h3
                        key={index}
                        style={style}
                        dangerouslySetInnerHTML={{
                            __html: line.replace(/<strong>(.*?)<\/strong>/g, '<strong style="font-weight:900; font-family: BoldItalic; color: #32503c;">$1</strong>')
                        }}
                    />
                ))}
            </div>
        );
    } catch {
        return answer.split('\n').map((line, index) => (
            <h3
                key={index}
                style={style}
                dangerouslySetInnerHTML={{
                    __html: line.replace(/<strong>(.*?)<\/strong>/g, '<strong style="font-weight:900; font-family: BoldItalic; color: #32503c;">$1</strong>')
                }}
            />
        ));
    }
};

const trustPoints = ["Free to play", "No real-money gambling", "No microtransactions"];

export const TrustPill = ({
    fontSize,
    marginTop = 0,
    marginBottom = 0,
}: {
    fontSize: number | string;
    marginTop?: number | string;
    marginBottom?: number | string;
}) => (
    <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        columnGap: "0.5em",
        rowGap: "0.25em",
        padding: "0.4em 0.95em",
        marginTop,
        marginBottom,
        maxWidth: "92%",
        background: "rgba(255, 255, 255, 0.55)",
        border: "1px solid rgba(50, 80, 60, 0.12)",
        borderRadius: "999px",
        boxShadow: "0 1px 6px rgba(50, 80, 60, 0.06)",
        backdropFilter: "blur(4px)",
    }}>
        {trustPoints.map((point, index) => (
            <React.Fragment key={point}>
                {index > 0 && (
                    <span style={{ color: "#7aa789", fontSize, lineHeight: 1 }}>•</span>
                )}
                <span style={{
                    color: "#4a6452",
                    fontFamily: "Regular",
                    fontSize,
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                    letterSpacing: "0.2px",
                }}>
                    {point}
                </span>
            </React.Fragment>
        ))}
    </div>
);

export const LogoAndTagLineDesktop = () => {
    const heightReference = getScreenSize().height * 0.7

    return (
        <div className="home-container" style={{
            display: "flex",
            height: "100%", width: "100%",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            flexDirection: "column"
        }}>
            <div style={{
                height: "100%", width: "100%", alignItems: "flex-start",
                justifyContent: "flex-end", zIndex: 2, display: "flex",
                flexDirection: "column",
                position: "relative", marginBottom: "20%"
            }}>
                {/* Big two-line header OUTSIDE the box */}
                <div style={{
                    marginLeft: heightReference * 0.04,
                    // paddingRight: heightReference * 0.07,
                    textAlign: "left",
                    marginBottom: heightReference * 0.015,
                    lineHeight: 1.1, display: "flex",
                    flexDirection: "row", width: "100%"
                }}>
                    <div style={{
                        paddingTop: "0px",
                        paddingBottom: "10px",
                        textAlign: "left",
                        lineHeight: 1.1, width: "100%"
                    }}>
                        <div style={{
                            color: "#2a4432",
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                heightReference * 0.13,
                                getScreenSize().width / getScreenSize().height < 1.4
                                    ? getScreenSize().width * 0.5
                                    : getScreenSize().width * 0.5,
                                header0_1.length,
                                200
                            ),
                            textAlign: "left",
                            textShadow: "2px 2px 2px rgba(255,255,255,1)",
                        }}>
                            {header0_1}
                        </div>
                        <div style={{
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                heightReference * 0.13,
                                getScreenSize().width / getScreenSize().height < 1.4
                                    ? getScreenSize().width * 0.5
                                    : getScreenSize().width * 0.5,
                                header0_1.length,
                                200
                            ),
                            textAlign: "left",
                            color: "#0f1f16",
                            textShadow: "2px 2px 2px rgba(255,255,255,1)",
                            whiteSpace: "nowrap",
                        }}>
                            {header0_2}
                        </div>
                    </div>
                </div>

                <div style={{ justifyContent: "center", height: "45%", width: "100%" }}>
                    <div style={{
                        margin: heightReference * 0.04,
                        padding: heightReference * 0.03,
                        background: 'linear-gradient(135deg, rgb(245, 255, 248) 0%, rgb(240, 255, 245) 25%, rgb(255, 255, 255) 50%, rgb(235, 254, 242) 75%, rgb(235, 254, 243) 100%)',
                        borderRadius: "20px",
                        boxShadow: `
                            0 8px 32px rgba(50, 80, 60, 0.12),
                            0 4px 16px rgba(50, 80, 60, 0.08),
                            0 2px 8px rgba(50, 80, 60, 0.04)
                        `,
                        position: 'relative',
                        overflow: 'hidden',
                        border: '1px solid rgba(50, 80, 60, 0.1)',
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0, left: 0, right: 0,
                            height: '50%',
                            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%)',
                            borderRadius: '20px 20px 0 0',
                            pointerEvents: 'none',
                        }} />

                        <div style={{ position: 'relative', zIndex: 1 }}>
                            {formatHeader(headerLevel2, {
                                color: "#2a4432",
                                fontFamily: "Italic",
                                textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.09,
                                    getScreenSize().width * (getIsMobile() ? 0.95 : 0.45),
                                    headerLevel2.length,
                                    88
                                ),
                                textAlign: "left",
                                margin: heightReference * 0.03,
                                marginLeft: "8%",
                                marginRight: "8%",
                                lineHeight: "1"
                            })}
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", marginTop: heightReference * 0.035 }}>
                        <TrustPill fontSize={heightReference * 0.021} />
                    </div>

                    <div style={{ marginBottom: heightReference * 0.03, marginTop: heightReference * 0.025 }}>
                        <DownloadButtonsDesktop placement="hero" height={heightReference * 0.14} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export const LogoAndTagLineTablet = () => {
    const widthReference = getScreenSize().width;
    const heightReference = Math.min(getScreenSize().height, widthReference * 1.1);

    return (
        <div className="home-container" style={{
            display: "flex",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            position: "relative",
            flexDirection: "column",
        }}>
            <div style={{
                height: "100%",
                width: "100%",
                alignItems: "center",
                justifyContent: "flex-start",
                zIndex: 2,
                display: "flex",
                flexDirection: "column",
                position: "relative",
            }}>
                {/* Big two-line header with logo inline */}
                <div style={{
                    marginLeft: heightReference * 0.04,
                    textAlign: "center",
                    marginBottom: heightReference * 0.012,
                    lineHeight: 1.1,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                }}>
                    <div style={{
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        textAlign: "left",
                        lineHeight: 1.1,
                    }}>
                        <div style={{
                            color: "#2a4432",
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                heightReference * 0.10,
                                widthReference * 0.65,
                                header0_2.length,
                                160
                            ),
                            textAlign: "center",
                            textShadow: "2px 2px 2px rgba(255,255,255,1)",
                        }}>
                            {header0_1}
                        </div>
                        <div style={{
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(
                                heightReference * 0.10,
                                widthReference * 0.65,
                                header0_2.length,
                                160
                            ),
                            textAlign: "center",
                            color: "#0f1f16",
                            textShadow: "2px 2px 2px rgba(255,255,255,1)",
                            whiteSpace: "nowrap",
                        }}>
                            {header0_2}
                        </div>
                    </div>

                    {/* Logo */}
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: heightReference * 0.15,
                        marginLeft: heightReference * 0.03,
                    }}>
                        <img style={{
                            objectFit: "contain",
                            height: heightReference * 0.15,
                            width: heightReference * 0.15,
                            background: 'linear-gradient(135deg, rgb(245, 255, 248) 0%, rgb(240, 255, 245) 25%, rgb(255, 255, 255) 50%, rgb(235, 254, 242) 75%, rgb(229, 254, 237) 100%)',
                            borderRadius: "50%",
                            padding: "5%",
                            boxShadow: `
                                0 12px 40px rgba(50, 80, 60, 0.15),
                                0 6px 20px rgba(50, 80, 60, 0.1),
                                0 3px 10px rgba(50, 80, 60, 0.06),
                                inset 0 1px 0 rgba(255, 255, 255, 0.8)
                            `,
                            border: '1px solid rgba(50, 80, 60, 0.12)',
                            transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                            src={AppLogo}
                            alt=""
                        />
                    </div>
                </div>

                {/* Tagline card + download buttons */}
                <div style={{
                    justifyContent: "center", display: "flex", position: "relative",
                    flexDirection: "column", alignItems: "center",
                    width: "100%",
                }}>
                    <div style={{
                        margin: heightReference * 0.03,
                        padding: heightReference * 0.025,
                        flexDirection: "column",
                        width: getScreenSize().width > getScreenSize().height ? "70%" : "90%",
                        background: 'linear-gradient(135deg, rgb(245, 255, 248) 0%, rgb(240, 255, 245) 25%, rgb(255, 255, 255) 50%, rgb(248, 255, 250) 75%, rgb(248, 255, 251) 100%)',
                        borderRadius: "20px",
                        boxShadow: `
                            0 8px 32px rgba(50, 80, 60, 0.12),
                            0 4px 16px rgba(50, 80, 60, 0.08),
                            0 2px 8px rgba(50, 80, 60, 0.04)
                        `,
                        position: 'relative',
                        overflow: 'hidden',
                        border: '1px solid rgba(50, 80, 60, 0.1)',
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0, left: 0, right: 0,
                            height: '50%',
                            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%)',
                            borderRadius: '20px 20px 0 0',
                            pointerEvents: 'none',
                        }} />

                        <div style={{ margin: heightReference * 0.025, position: 'relative', zIndex: 1, flexDirection: "column", display: "flex" }}>
                            <span style={
                                {
                                    color: "#2a4432",
                                    fontFamily: "Italic",
                                    textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                                    fontSize: getAdjustingFontSizeByHeightWidth(
                                        heightReference * 0.1,
                                        widthReference * 0.65,
                                        headerLevel2.length,
                                        88
                                    ),
                                    textAlign: "center",

                                    marginLeft: "8%",
                                    marginRight: "8%",
                                    lineHeight: "0.9",
                                }
                            }>

                                {headerLevel2_mobile_1}
                            </span>
                            <span style={
                                {
                                    color: "#2a4432",
                                    fontFamily: "Italic",
                                    textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                                    fontSize: getAdjustingFontSizeByHeightWidth(
                                        heightReference * 0.1,
                                        widthReference * 0.65,
                                        headerLevel2.length,
                                        88
                                    ),
                                    textAlign: "center",
                                    marginTop: heightReference * 0.025,
                                    marginLeft: "8%",
                                    marginRight: "8%",
                                    lineHeight: getScreenSize().height < getScreenSize().width * 0.6 ? "1" : "0.9",
                                }
                            }>

                                {headerLevel2_Tablet_2}
                            </span>
                            {/* {formatHeader(headerLevel2, {
                                color: "#2a4432",
                                fontFamily: "Italic",
                                textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.1,
                                    widthReference * 0.55,
                                    headerLevel2.length,
                                    88
                                ),
                                textAlign: "center",
                                margin: heightReference * 0.025,
                                marginLeft: "8%",
                                marginRight: "8%",
                                lineHeight: getScreenSize().height < getScreenSize().width * 0.6 ? "1" : "0.9",
                            })} */}
                        </div>
                    </div>

                    <TrustPill
                        fontSize={heightReference * 0.02}
                        marginTop={heightReference * 0.025}
                    />

                    {/* Download button */}
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: heightReference * 0.025,
                        marginBottom: heightReference * 0.02,
                        height: heightReference * 0.1,
                    }}>
                        <img
                            src={getMobileDownloadButtonValues().source}
                            style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                            }}
                            alt=""
                            onClick={() => { const link = getMobileDownloadButtonValues().link; trackDownloadClick(link, "hero"); window.open(link); }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};


export const LogoAndTagLineMobile = () => {
    const heightReference = getScreenSize().height;
    const widthReference = getScreenSize().width;

    return (
        <div className="home-container" style={{
            display: "flex",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            position: "relative",
            flexDirection: "column"
        }}>
            <div style={{
                height: "100%", width: "100%", alignItems: "center",
                justifyContent: "flex-start", paddingTop: "6%", zIndex: 2, display: "flex",
                flexDirection: "column",
            }}>

                {/* Big header */}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    boxSizing: "border-box",
                    marginBottom: "4%",
                }}>
                    <div style={{
                        color: "#2a4432",
                        fontFamily: "Bold",
                        fontSize: getAdjustingFontSizeByHeightWidth(
                            heightReference * 0.06,
                            widthReference * 0.9,
                            header0_2.length,
                            160
                        ),
                        textAlign: "center",
                        textShadow: "2px 2px 2px rgba(255,255,255,1)",
                        lineHeight: 1.1,
                    }}>
                        {header0_1}
                    </div>
                    <div style={{
                        fontFamily: "Bold",
                        fontSize: getAdjustingFontSizeByHeightWidth(
                            heightReference * 0.06,
                            widthReference * 0.9,
                            header0_2.length,
                            160
                        ),
                        textAlign: "center",
                        color: "#0f1f16",
                        textShadow: "2px 2px 2px rgba(255,255,255,1)",
                        lineHeight: 1.1,
                        whiteSpace: "nowrap",
                    }}>
                        {header0_2}
                    </div>
                </div>

                {/* Tagline card */}
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    paddingLeft: "2.5%",
                    paddingRight: "2.5%",
                    marginBottom: "7%",
                    boxSizing: "border-box",
                    flexDirection: "column"
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: "10px",
                        boxShadow: `
                            0 8px 32px rgba(50, 80, 60, 0.12),
                            0 4px 16px rgba(50, 80, 60, 0.08),
                            0 2px 8px rgba(50, 80, 60, 0.04)
                        `,
                        border: '1px solid rgba(50, 80, 60, 0.1)',
                        position: 'relative',
                        overflow: 'hidden',
                        width: "100%",
                        padding: "5% 6%",
                        paddingLeft: "4%",
                        paddingRight: "4%",
                        boxSizing: "border-box",
                        maxWidth: "150vh",
                    }}>
                        {/* Top gloss overlay */}
                        <div style={{
                            position: 'absolute',
                            top: 0, left: 0, right: 0,
                            height: '50%',
                            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%)',
                            borderRadius: '20px 20px 0 0',
                            pointerEvents: 'none',
                        }} />

                        <div style={{ position: 'relative', zIndex: 1 }}>
                            {formatHeader(headerLevel2_mobile_1, {
                                color: "#2a4432",
                                fontFamily: "Regular",
                                textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.04,
                                    widthReference * 0.75,
                                    headerLevel2_mobile_1.length,
                                    88
                                ),
                                textAlign: "left",
                                marginTop: "1%",
                                marginBottom: "3%",
                                lineHeight: "1.2",
                                whiteSpace: "normal",
                            })}
                            {formatHeader(headerLevel2_mobile_2, {
                                color: "#2a4432",
                                fontFamily: "Regular",
                                textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                                fontSize: getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.04,
                                    widthReference * 0.75,
                                    headerLevel2_mobile_1.length,
                                    88
                                ),
                                textAlign: "left",
                                lineHeight: "1.2",
                                whiteSpace: "normal",
                            })}
                        </div>
                    </div>
                </div>

                {/* Phone screenshots */}
                {/* <div style={{ marginBottom: "5%", flexDirection: "row", display: "flex", position: "relative", width: "100%", justifyContent: "center", alignItems: "center" }}>
                    <div style={{
                        height: heightReference * 0.35 * 0.85,
                        width: heightReference * 0.35 * 0.85 / 2.02535,
                        flexShrink: 0,
                        marginLeft: "1%", marginRight: "1%"
                    }}>
                        <FlexiblePhoneStillImage
                            marginHorizontal={"3%"}
                            marginTop={"1%"}
                            image={GamePlayScreenShot}
                            videoBorderRadius={1000 * ((getScreenSize().width ** 0.5) * 0.5 / 400)}
                        />
                    </div>
                    <div style={{
                        height: heightReference * 0.35 * 0.85,
                        width: heightReference * 0.35 * 0.85 / 2.02535,
                        flexShrink: 0,
                        marginLeft: "1%", marginRight: "1%"
                    }}>
                        <FlexiblePhoneStillImage
                            marginHorizontal={"3%"}
                            marginTop={"1%"}
                            image={DelighterStill}
                            videoBorderRadius={1000 * ((getScreenSize().width ** 0.5) * 0.5 / 400)}
                        />
                    </div>
                    <div style={{
                        height: heightReference * 0.35 * 0.85,
                        width: heightReference * 0.35 * 0.85 / 2.02535,
                        flexShrink: 0,
                        marginLeft: "1%", marginRight: "1%"
                    }}>
                        <FlexiblePhoneStillImage
                            marginHorizontal={"3%"}
                            marginTop={"1%"}
                            image={BluffsPie}
                            videoBorderRadius={1000 * ((getScreenSize().width ** 0.5) * 0.5 / 400)}
                        />
                    </div>
                </div> */}

                {/* {formatHeader(headerLevel2_mobile_3, {
                    color: "#2a4432",
                    fontFamily: "Regular",
                    textShadow: "0px 2px 8px rgba(255, 255, 255, 0.8), 0px 1px 3px rgba(50, 80, 60, 0.1)",
                    fontSize: getAdjustingFontSizeByHeightWidth(
                        heightReference * 0.02,
                        widthReference * 0.5,
                        headerLevel2_mobile_3.length,
                        88
                    ),
                    textAlign: "center",
                    opacity: 0.8,
                    lineHeight: "1.2",
                    whiteSpace: "normal",
                })} */}

                <TrustPill
                    fontSize={Math.min(heightReference * 0.018, widthReference * 0.035)}
                    marginBottom={heightReference * 0.025}
                />

                {/* Download button */}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "60%",
                    maxWidth: "50vh",
                    marginTop: heightReference * 0.01,
                    marginBottom: heightReference * 0.02,
                    gap: heightReference * 0.015,
                }}>
                    <img
                        src={getMobileDownloadButtonValues().source}
                        style={{
                            width: "100%",
                            objectFit: "contain",
                            borderRadius: "15px",
                            boxShadow: "0px 0px 10px 3px white",
                            cursor: "pointer",
                        }}
                        alt=""
                        onClick={() => { const link = getMobileDownloadButtonValues().link; trackDownloadClick(link, "hero"); window.open(link); }}
                    />
                </div>
            </div>
        </div>
    );
};